import ButtonCookie from "../button/ButtonCookie";
import Button from "../button/Button";
import React, { useState, useEffect, useContext } from "react";
import Image from "next/image";
import { Row, Col, Container } from "react-bootstrap";
import CookieRow from "./CookieRow";
import { deleteCookies, acceptCookies } from "../../utils/cookieUtils";
import { getCookieConsentValue } from "react-cookie-consent";
import styles from "../../style/Popup.module.css";
import styled from "styled-components";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { Context } from "../../Context";

const Buttons = styled.div`
  margin-top: 2rem;

  @media (min-width: 700px) {
    display: flex;
    justify-content: space-between;
  }
`;

const CookieConsentPopup = () => {
  const { setShowPopup, showPopup } = useContext(Context);
  const [cookieSettings, setCookieSettings] = useState({
    necessary: true,
    preference: false,
    statistics: false,
    marketing: false,
  });

  const [showOverview, setShowOverview] = useState(true);

  const saveCookieSettings = (selectedCookies?: string): void => {
    if (selectedCookies === "all") {
      setCookieSettings({
        necessary: true,
        preference: true,
        statistics: true,
        marketing: true,
      });
      acceptCookies({
        necessary: true,
        preference: true,
        statistics: true,
        marketing: true,
      });
    } else {
      acceptCookies(cookieSettings);
    }
    setShowPopup(false);
  };
  const handleChangeCookieSettings = () => {
    setShowOverview(false);
  };
  const handleNavigateToOverview = () => {
    setShowOverview(true);
  };
  const handleChange = (attr, value) => {
    setCookieSettings((prevState) => ({ ...prevState, [attr]: value }));
  };

  const list = ["Asegurar el funcionamiento técnico adecuado de las páginas web.", "Personalizar las páginas web según tu uso y tus preferencias.", "Medir el tráfico y el uso de manera que podamos mejorar las páginas web.", "Presentarte contenido relevante y anuncios personalizados."]

  const buletPoints = list.map((row, index) => (
    <div key={index} style={{ display: "flex", marginBottom: ".5em" }}>
      <div style={{ paddingRight: ".3em" }}>✓ </div>
      <div>
        {row}
      </div>
    </div>
  ));

  return (
    <>
      {showPopup && (
        <div className={styles.cookie_banner_overlay}>
          <div className={styles.cookie_banner}>
            {showOverview ? (
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    style={{ justifyContent: "space-between", display: "flex" }}
                  >
                    <p
                      style={{
                        fontSize: "26px",
                        fontWeight: "bold",
                        marginTop: "10px",
                      }}
                    >
                      Este sitio web utiliza cookies
                    </p>{" "}
                  </div>
                  <div
                    className={styles.logo}
                  >
                    <Image
                      src="/lea-bank-classic.png"
                      width={50}
                      height={50}
                      alt="lea bank logo"
                    />
                  </div>
                </div>
                <div>
                  <div className={styles.subtitle}>
                    El uso de cookies en nuestras páginas web tiene un propósito
                    fundamental:
                  </div>
                  {buletPoints}
                </div>{" "}
                <Buttons>
                  <Button
                    primary
                    cookieType
                    onClick={() => saveCookieSettings("all")}
                  >
                    Aceptar todo
                  </Button>{" "}
                  <Button cookieType onClick={handleChangeCookieSettings}>
                    Configurar cookies
                  </Button>{" "}
                </Buttons>{" "}
              </>
            ) : (
              <>
                {" "}
                <div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{ display: "flex", cursor: "pointer" }}
                      onClick={handleNavigateToOverview}
                    >
                      <div style={{ fontSize: "22px", paddingTop: "5px" }}>
                        <HiArrowNarrowLeft />
                      </div>
                      <div
                        style={{
                          fontSize: "22px",
                          paddingTop: "10px",
                          paddingLeft: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        Atrás
                      </div>
                    </div>
                    <div
                      style={{
                        justifyContent: "right",
                        display: "flex",
                      }}
                    >
                      <Image
                        src="/lea-bank-classic.png"
                        width={50}
                        height={50}
                        alt="lea bank logo"
                      />
                    </div>
                  </div>
                </div>{" "}
                <div>
                  {" "}
                  <div
                    style={{
                      fontSize: "26px",
                      fontWeight: "bold",
                      marginTop: "1rem",
                      marginBottom: ".5rem",
                    }}
                  >
                    Cookies
                  </div>
                  <div style={{
                    fontSize: "20px",
                    marginBottom: "1rem",
                  }}>
                    Para disfrutar de la mejor experiencia en nuestro sitio,
                    recomendamos activar todos los tipos de cookies.
                  </div>
                  <CookieRow
                    title={"Técnicas"}
                    description={
                      "Necesitamos utilizar cookies técnicas para garantizar el correcto funcionamiento del sitio web. Estas cookies están siempre activadas. Puedes ajustar la configuración en tu navegador para desactivarlas, pero no podemos garantizar que el sitio web funcione de manera óptima si lo haces."
                    }
                    checked={true}
                    disabled
                  />{" "}
                  <CookieRow
                    title={"Preferencias"}
                    description={
                      "Estas cookies se utilizan para recordar tus preferencias como usuario y proporcionarnos la base para optimizar el contenido y las soluciones que ofrecemos especialmente para ti."
                    }
                    checked={cookieSettings.preference}
                    handleChange={(e) =>
                      handleChange("preference", e.target.checked)
                    }
                  />{" "}
                  <CookieRow
                    title={"Estadísticas"}
                    description={
                      "Nos ayudan a recopilar estadísticas anónimas que nos permiten comprender cómo se utilizan nuestros sitios web, cuáles son las páginas más visitadas y cuántos visitantes recibimos."
                    }
                    checked={cookieSettings.statistics}
                    handleChange={(e) =>
                      handleChange("statistics", e.target.checked)
                    }
                  />{" "}
                  <CookieRow
                    title={"Marketing"}
                    description={
                      "Estas cookies, ya sean propias o de terceros, se utilizan para analizar el comportamiento de los usuarios en nuestros sitios web. Permiten la personalización de la publicidad en otros sitios web y redes sociales, mostrándote anuncios que se ajustan a tus intereses y comportamiento en línea. Si desactivas esta opción, seguirás viendo publicidad, aunque no estará adaptada a tus preferencias personales."
                    }
                    checked={cookieSettings.marketing}
                    handleChange={(e) =>
                      handleChange("marketing", e.target.checked)
                    }
                  />{" "}
                </div>{" "}
                <Buttons>
                  {" "}
                  <Button
                    primary
                    onClick={() => saveCookieSettings("all")}
                  >
                    Aceptar todo
                  </Button>{" "}
                  <Button onClick={() => saveCookieSettings()}>
                    Guardar configuración
                  </Button>{" "}
                </Buttons>{" "}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default CookieConsentPopup;
